/**
 * @generated SignedSource<<8db5a2b2aea1d8d8917028322722525e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamHeaderDashboardButtonQuery$variables = Record<PropertyKey, never>;
export type TeamHeaderDashboardButtonQuery$data = {
  readonly store: {
    readonly dashboards: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
  };
};
export type TeamHeaderDashboardButtonQuery = {
  response: TeamHeaderDashboardButtonQuery$data;
  variables: TeamHeaderDashboardButtonQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Dashboard",
  "kind": "LinkedField",
  "name": "dashboards",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamHeaderDashboardButtonQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TeamHeaderDashboardButtonQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "383aa3df90bf954d0de3a9234f1e785f",
    "id": null,
    "metadata": {},
    "name": "TeamHeaderDashboardButtonQuery",
    "operationKind": "query",
    "text": "query TeamHeaderDashboardButtonQuery {\n  store {\n    dashboards {\n      id\n      name\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bf5a63f157c9f62e042742687141d2ac";

export default node;
